import React from 'react';

export const Mail = ({
  color,
  width,
  height,
  top,
  left
}: {
  color?: string;
  width?: string;
  height?: string;
  top?: string;
  left?: string;
}): JSX.Element => {
  const className = 'icon icon--mail';
  color = color || '#0076CC';
  width = width || '20';
  height = height || '16';
  top = top || '0';
  left = left || '0';

  return (
    <svg
      width={width}
      height={height}
      viewBox={`${left} ${top} ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M1 4L8.8906 9.2604C9.5624 9.70827 10.4376 9.70827 11.1094 9.2604L19 4M3 15H17C18.1046 15 19 14.1046 19 13V3C19 1.89543 18.1046 1 17 1H3C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Mail;
